import React from 'react';
import { ScreenReaderOnly } from "../screen-reader-only";
import { jsx as ___EmotionJSX } from "@emotion/core";
export var LiveRegionBlock = function LiveRegionBlock(_ref) {
  var children = _ref.children,
      role = _ref.role,
      ariaLive = _ref['aria-live'];
  return ___EmotionJSX(ScreenReaderOnly, {
    "aria-atomic": true,
    role: role,
    "aria-live": ariaLive,
    "data-test-component": "StencilLiveRegion"
  }, !!children ? children : '');
};